import { MapPin, Mail, Phone, Clock } from "lucide-react";
import { BUSINESS, mapsSearchUrl } from "../../config/business";
import OpenNowBadge from "../OpenNowBadge";

export default function TopBar() {
  return (
    <div className="bg-deep text-white text-xs font-body" data-testid="top-info-bar">
      <div className="section flex flex-wrap items-center justify-between gap-x-6 gap-y-1 py-2">
        <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
          <a
            data-testid="topbar-address"
            href={mapsSearchUrl()}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 hover:text-cta transition-colors"
          >
            <MapPin className="h-3.5 w-3.5" /> {BUSINESS.address.full}
          </a>
          <a
            data-testid="topbar-email"
            href={`mailto:${BUSINESS.email}`}
            className="hidden sm:inline-flex items-center gap-1.5 hover:text-cta transition-colors"
          >
            <Mail className="h-3.5 w-3.5" /> {BUSINESS.email}
          </a>
        </div>
        <div className="flex items-center gap-x-5">
          <span className="hidden md:inline-flex items-center gap-1.5 text-white/80">
            <Clock className="h-3.5 w-3.5" /> {BUSINESS.hoursSummary}
          </span>
          <OpenNowBadge className="text-[11px] [&>span]:!text-white" />
          <a
            data-testid="topbar-phone"
            href={`tel:${BUSINESS.phoneTel}`}
            className="inline-flex items-center gap-1.5 font-semibold hover:text-cta transition-colors"
          >
            <Phone className="h-3.5 w-3.5" /> {BUSINESS.phoneDisplay}
          </a>
        </div>
      </div>
    </div>
  );
}
